import { pick } from 'lodash-es'

export const omit = (toClean: Record<string, unknown>, toOmit: string[]): Record<string, unknown> => {
  const cleanedKeys = Object.keys(toClean).filter((key) => toOmit.indexOf(key) === -1)

  return pick(toClean, cleanedKeys)
}
